import GetCarrierDisplayName from '../../../../components/data-driven-logo/get-carrier-display-name';

export const buildCustomPackages = (packages) => {
  return packages.filter((pkg) => pkg.isCustom && !pkg.isHidden).sort((a, b) => a.name.localeCompare(b.name));
};

export const getCarrierPackages = (packages = [], carrier = {}) => {
  const carrierPackages = packages.filter((pkg) => pkg.carrierId === carrier.carrierId && !pkg.isHidden);
  return [
    {
      id: carrier?.carrierId,
      groupName: GetCarrierDisplayName(carrier?.carrierId),
      packages: carrierPackages,
    },
  ];
};
